import { TextField, Typography } from "@mui/material";
import { useContext, useState } from "react";

import { LanguageContext } from "src/contexts/language";
import { MapContext } from "src/contexts/map";
import { Type_Props_Input } from "src/types/input";
import { handleInputBlur } from "src/utils/element";

const TextArea = ({ data }: Type_Props_Input) => {
    const { language } = useContext(LanguageContext);
    const { newElement, updateNewElement } = useContext(MapContext);
    const [selectedValue, setSelectedValue] = useState(
        newElement?.data?.find((input) => input.input_id === data.id)?.value ||
            "",
    );

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setSelectedValue(event.target.value);
    };

    if (!data) return null;

    return (
        <>
            <Typography color="text.secondary">
                {data.title[language]}
            </Typography>
            <TextField
                value={selectedValue}
                onChange={handleChange}
                onBlur={() =>
                    handleInputBlur({
                        data,
                        selectedValue,
                        newElement,
                        updateNewElement,
                    })
                }
                fullWidth
                multiline
                rows={4}
                variant="outlined"
            />
        </>
    );
};

export default TextArea;
